import React, { PropsWithChildren } from 'react';

import styles from './header.module.scss';

type HeaderProps = React.PropsWithChildren<{
  title?: string;

  /** Optional content rendered next to the title, e.g. a tab selector **/
  afterTitle?: React.ReactNode;
}>;

export const Header: React.FC<PropsWithChildren<HeaderProps>> = ({
  title,
  afterTitle,
  children,
}) => (
  <header className={styles['header']}>
    <div className={styles['leading']}>
      <h1 className={styles['title']}>{title}</h1>
      {afterTitle}
    </div>
    <div className={styles['items']}>{children}</div>
  </header>
);
